import { create } from 'zustand';

export interface NotificationData {
  show: boolean;
  message: string;
  severity: 'info' | 'error' | 'success' | 'warning';
}

export interface UIState {
  loading: boolean;
  loadingCount: number;
  notification: NotificationData;
  showLoading: () => void;
  hideLoading: () => void;
  showInfoToast: (message: string) => void;
  showErrorToast: (message: string) => void;
  showSuccessToast: (message: string) => void;
  showWarningToast: (message: string) => void;
  hideToast: () => void;
}

export const useUIStore = create<UIState>()((set) => ({
  loading: false,
  loadingCount: 0,
  notification: {
    show: false,
    message: '',
    severity: 'info'
  },
  showLoading: () => {
    set((s) => ({
      loading: true,
      loadingCount: s.loadingCount + 1
    }));
  },
  hideLoading: () => {
    set((s) => ({
      loading: s.loadingCount - 1 > 0,
      loadingCount: s.loadingCount > 0 ? s.loadingCount - 1 : 0
    }));
  },
  showInfoToast: (message) =>
    set({
      notification: {
        show: true,
        message: message,
        severity: 'info'
      }
    }),
  showErrorToast: (message) =>
    set({
      notification: {
        show: true,
        message: message,
        severity: 'error'
      }
    }),
  showSuccessToast: (message) =>
    set({
      notification: {
        show: true,
        message: message,
        severity: 'success'
      }
    }),
  showWarningToast: (message) =>
    set({
      notification: {
        show: true,
        message: message,
        severity: 'info'
      }
    }),
  hideToast: () =>
    set({
      notification: {
        show: false,
        message: '',
        severity: 'info'
      }
    })
}));
